import { db } from "../config/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { getOrSetCache, invalidateCache } from "../utils/cacheUtil";

const DEFAULT_COLLECTION_CACHE_TTL_MS = 5 * 60 * 1000;

class FireStoreService {
  static async fetchData(collectionName, options = {}) {
    const { forceRefresh = false, ttlMs = DEFAULT_COLLECTION_CACHE_TTL_MS } = options;
    const cacheKey = `firestore:collection:${collectionName}`;

    if (forceRefresh) {
      invalidateCache(cacheKey);
    }

    return getOrSetCache(
      cacheKey,
      async () => {
        try {
          const querySnapshot = await getDocs(collection(db, collectionName));

          if (querySnapshot.empty) {
            console.log("No documents found in Firestore.");
            return [];
          }

          const data = querySnapshot.docs.map((document) => ({
            id: document.id,
            ...document.data(),
          }));

          return data;
        } catch (error) {
          console.error("Error fetching data from Firestore:", error);
          throw new Error("Unable to fetch data from Firestore");
        }
      },
      ttlMs,
    );
  }
}

export default FireStoreService;
